import { Box, Typography } from '@customink/pigment-react';

import { colorPurple } from '@/utils/designTokens';

type DeliveryOptionHeaderProps = {
  title: string;
  newFeature?: boolean;
};

export const DeliveryOptionHeader = ({
  title,
  newFeature = false,
}: DeliveryOptionHeaderProps) => {
  return (
    <Typography variant="heading6">
      {title}{' '}
      {newFeature && (
        <Box component="span" sx={{ color: colorPurple }}>
          New!
        </Box>
      )}
    </Typography>
  );
};
